module.exports = __webpack_public_path__ + "img/house-open.925e21ca.png";